// styles
import classnames from 'classnames/bind';
import ReloadButton from 'components/Button/ReloadButton';
// components
import NoDataBanner from 'components/DismissBanner/NoDataBanner';
import Indicator from 'components/Indicator';
import WarningIndicator from 'components/Indicator/WarningIndicator';
import AssessmentModal from 'components/instances/AssessmentModal';
import Table from 'components/Table';
import Typography from 'components/Typography';
// icons
import { ReactComponent as AlertIcon } from 'icons/alert-icon.svg';
import { debounce, isEmpty } from 'lodash';
import React, { createRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAssessmentProgress } from 'store/actions/classroom';
// utils
import { createEmptyTableData } from 'utils/misc';
import { alphabeticalSort, valueSort } from 'utils/sort';

import styles from './Ticket.module.scss';

const cx = classnames.bind(styles);

const googleDocLinks = [
  {
    missionName: 'm1_p1_new_in_town',
    url: 'https://docs.google.com/document/d/1utvCthDLwqo6XdGAq9tfzIRDcYK7FWNyQvfPmYwBsqQ/edit?usp=sharing',
  },
  {
    missionName: 'm1_p3_march_of_the_apprentices',
    url: 'https://docs.google.com/document/d/1X5kRrtEgMHSewaZXW2vXAp73E6vbS1BFjAbJMSNUc1w/edit?usp=sharing',
  },
  {
    missionName: 'm1_p6_epilogue',
    url: 'https://docs.google.com/document/d/15ISvYlB1X7xMsxqB0qnihpLwF4fKBNuWBorn6RdxVTc/edit?usp=sharing',
  },
  {
    missionName: 'm3_p1_seeing_shadows',
    url: 'https://docs.google.com/document/d/1Qo_neGHPgjXYvL8TfBnMRAdWOZOLaFYDYlYwZBsNuR8/edit?usp=sharing',
  },
  {
    missionName: 'm3_p3_the_iron_horse',
    url: 'https://docs.google.com/document/d/1DJaui2qIfiT2GaV2euIPr2ld4Va8jLxMzTYUnaLFP_8/edit?usp=sharing',
  },
  {
    missionName: 'm3_p5_battle_of_the_greasy_grass',
    url: 'https://docs.google.com/document/d/1Ve2lR9_RPvI9ZnMQ9yjacAM1-XrTcVTZ/edit?usp=sharing',
  },
  {
    missionName: 'm4_p1_finding_home',
    url: 'https://docs.google.com/document/d/1k2hvpy2TWYHaLCIr1iTIijbEPrEmkPn0-BSvIMqj-Po/edit?usp=sharing',
  },
  {
    missionName: 'm4_p3_a_night_to_remember',
    url: 'https://docs.google.com/document/d/1HhDtLrdXuP_eNejHD16uS4G3ex4Wh6PXCJFzH4uh9IA/edit?usp=sharing',
  },
  {
    missionName: 'm4_p5_uprising_of_the_20000',
    url: 'https://docs.google.com/document/d/1EPrayPBHmZr2eQbC8KarPmznGphjtql46KjNeMAf_rw/edit?usp=sharing',
  },
  {
    missionName: 'm5_p1_boom_to_bust',
    url: 'https://docs.google.com/document/d/1J1-5rPyTDI7FiPDbDHIusFk7iyYye-LkY1DPMKxlYwk/edit?usp=sharing',
  },
  {
    missionName: 'm5_p3_riding_the_rails',
    url: 'https://docs.google.com/document/d/167T-g5C23kRDqq1lHoF2Jrxb95U0xsYOz0w-Q13YE3s/edit?usp=sharing',
  },
  {
    missionName: 'm5_p5_california_or_dust',
    url: 'https://docs.google.com/document/d/1wlfTT79q5_IdmmPl2BQOB_g1K4TtYwW8Lbm9qElJ6BM/edit?usp=sharing',
  },
  {
    missionName: 'm6_p1_manzanar',
    url: 'https://docs.google.com/document/d/18Fle3n5maqc565v7OJgT9jQBSKcaY5Dv94tcET9Eqps/edit?usp=sharing',
  },
  {
    missionName: 'm6_p2_finding_a_way',
    url: 'https://docs.google.com/document/d/1-CXfYVOQcmWk1if3Mwomu4g4uHC3afqei3A6fmnQ-D0/edit?usp=sharing',
  },
  {
    missionName: 'm6_p3_allegiance',
    url: 'https://docs.google.com/document/d/1l-Vdnqn8MYB2tmAQRY5cLNatGlBrP6UtpSxH__50UR0/edit?usp=sharing',
  },
  {
    missionName: 'm7_p1_welcome_to_greenwood',
    url: 'https://docs.google.com/document/d/1WXB9XDAykJOJuiqoDq_cL-edistMK3Lfnwz9XQDd7ag/edit?usp=sharing',
  },
  {
    missionName: 'm7_p2_a_little_light',
    url: 'https://docs.google.com/document/d/1acncvdfDxJwLsulEYoZG7Bb6CdRtWrKBTD1OIhCXeQQ/edit?usp=sharing',
  },
  {
    missionName: 'm7_p3_jim_crow_must_go',
    url: 'https://docs.google.com/document/d/1IvtDtdSoCLV2UYSXVv88fcaq8afC89cRlFreECOgAgI/edit?usp=sharing',
  }
];

const studentRenderer = ({ first_name, last_name_initial, username }) => (
  <Typography className={cx('table-text')}>
    {!!first_name ? `${first_name} ${!!last_name_initial ? `${last_name_initial}.` : ''}` : username}
  </Typography>
);
const questionRenderer =
  (index) =>
    ({ results }) =>
    (
      <div className={cx('centered-wrapper')}>
        {results === '--' ? (
          <Typography className={cx('table-text')}>{results}</Typography>
        ) : (
          <Indicator checked={results[index]} />
        )}
      </div>
    );

const overallRenderer = ({ results, score }) => {
  const scoreRatio = score / Object.keys(results).length;

  return score === '--' ? (
    <Typography className={cx('table-text', 'empty-score')}>{score}</Typography>
  ) : (
    <div className={cx('centered-wrapper')}>
      <Typography isAlert={scoreRatio < 0.5} className={cx('table-text')}>
        {score}/{Object.keys(results).length} ({Math.floor(scoreRatio * 100)}
        <span>%</span>){scoreRatio < 0.5 && <AlertIcon className="mgb-10" />}
      </Typography>
    </div>
  );
};

const Ticket = () => {
  const [assessmentModalData, setAssessmentModalData] = useState({});
  const [questionRefs, setQuestionRefs] = useState({});
  const [googleDocLink, setGoogleDocLink] = useState('');
  const [pdfLink, setPdfLink] = useState('');
  const { ticketId } = useParams();
  const {
    currPart = {},
    classId,
    missionId,
    isLoading,
    currentMission,
    assessment: {
      id: assessmentId,
      questions = [],
      classroom_assessments: assessments,
      totalScorePerQuestion = {},
    } = {},
  } = useSelector(({ classroom = {} }) => {
    const currPart = (classroom?.currentMission?.parts || []).find(({ id }) => +id === +ticketId);

    return {
      currPart,
      classId: classroom.id,
      missionId: classroom?.currentMission?.id,
      isLoading: classroom.isLoading,
      assessment: classroom.assessmentTicket,
      currentMission: classroom.currentMission.number,
    };
  });
  const dispatch = useDispatch();

  const hasData = assessments && assessments.length !== 0;

  const handleClickQuestion = (data) => setAssessmentModalData(data);

  let columns = [
    {
      name: 'Student',
      width: 270,
      renderer: studentRenderer,
      sortFunction: alphabeticalSort(['first_name', 'username']),
    },
  ];

  if (!isLoading) {
    if (hasData) {
      Object.keys(assessments[0].results).forEach((_, idx) =>
        columns.push({
          name: `Question ${idx + 1}`,
          width: 100,
          renderer: questionRenderer(idx + 1),
          centered: true,
          onClick: () => questionRefs[idx + 1].current && questionRefs[idx + 1].current.click(),
        }),
      );
    } else {
      const emptyCols = Array(questions.length)
        .fill()
        .map((_, idx) => ({
          name: `Question ${idx + 1}`,
          width: 100,
          renderer: questionRenderer(idx + 1),
          centered: true,
          onClick: () => handleClickQuestion({ ...questions[idx] }),
        }));
      columns = columns.concat(emptyCols);
    }
  }
  columns.push({
    name: 'Overall Score',
    width: 150,
    renderer: overallRenderer,
    centered: true,
    sortFunction: valueSort('score'),
  });

  const handleFetchAssessmentData = () => dispatch(getAssessmentProgress(classId, missionId, +ticketId));

  //Fetch assessment pdf and gDocs links
  useEffect(() => {
    const missionName = `m${currentMission}_p${currPart.title.replace(/:/g, '').replace(/\s/g, '_').toLowerCase().replace(',', '').toLowerCase()}`;
    const pdfUrl = `/wp-content/uploads/pdf/${missionName}.pdf`;

    fetch(pdfUrl, { method: 'HEAD' })
      .then((res) => {
        if (res.ok) {
          setPdfLink(pdfUrl);
        }
      })
      .catch(() => {
        setPdfLink('');
      });

    const googleDoc = googleDocLinks.find((doc) => doc.missionName === missionName);

    if (googleDoc) {
      setGoogleDocLink(googleDoc.url);
    } else {
      setGoogleDocLink('');
    }

  }, [currentMission, currPart]);

  // fetch assessment data
  useEffect(() => {
    if (!!ticketId && !!classId && !!missionId && !isLoading) {
      handleFetchAssessmentData();
    }
  }, [ticketId, classId, missionId, dispatch]);

  useEffect(() => {
    if (questions.length > 0 && isEmpty(questionRefs)) {
      questions.forEach(({ number }) => setQuestionRefs((prev) => ({ ...prev, [number]: createRef() })));
    }
  }, [questions]);

  const assessmentRowRenderer = () => (
    <tr className={cx('assessment-row')}>
      <td className={cx('assessment-row--cell')}>
        <Typography className={cx('table-text')}>Class Performance</Typography>
      </td>
      {questions.map(({ students_answers_count, id, ...restAssessmentData }, idx) => {
        const scoreRatio = totalScorePerQuestion[idx + 1] / students_answers_count;
        const isBelowHalf = scoreRatio < 0.5;
        const percentage = Math.floor(scoreRatio * 100);

        return (
          <td
            key={id}
            className={cx('assessment-row--cell', 'centered', 'bg-white', { alert: isBelowHalf && hasData })}
          >
            <div className={cx('inner-wrapper')}>
              {!hasData ? (
                <Typography className={cx('table-text', { 'empty-cell': !hasData })}>--</Typography>
              ) : (
                <>
                  <Typography
                    ref={questionRefs[idx + 1]}
                    className={cx('table-text')}
                    onClick={() =>
                      handleClickQuestion({
                        students_answers_count,
                        id,
                        percentage,
                        scoreRatio,
                        ...restAssessmentData,
                      })
                    }
                  >
                    {percentage}
                    <span>%</span>
                  </Typography>
                  <Typography
                    type="body-xs"
                    onClick={() => questionRefs[idx + 1].current && questionRefs[idx + 1].current.click()}
                  >
                    CORRECT
                  </Typography>
                  {isBelowHalf && <WarningIndicator className={cx('indicator')} />}
                </>
              )}
            </div>
          </td>
        );
      })}
      <td className={cx('assessment-row--cell')}>
        <Typography className={cx('table-text', 'overall-fixed')}>--</Typography>
      </td>
    </tr>
  );
  return (
    <div className={cx('container')}>
      {assessments && !hasData && !isLoading && <NoDataBanner className="mgb-35" />}
      <div className={cx('title-wrapper') + ' mgb-10'}>
        <Typography type="body-s">
          Exit Ticket Assessment
        </Typography>
        {assessments && (
          <Typography className={cx('header-text')} type="body-s">
            Answer Key & Printable Questions
          </Typography>
        )}
      </div>
      <div className={cx('header-wrapper')}>
        <ReloadButton variant="light" onClick={debounce(() => handleFetchAssessmentData(), 500)} />
        <Typography className="mgl-15" type="h4">
          Part {currPart.title}
        </Typography>
        {assessments && (
          <ul className={cx('header-links')}>
            {pdfLink && (
              <li><a target='__blank' href={pdfLink}>
                {`PDF: ${currPart.title}`}
              </a></li>
            )}
            {googleDocLink && (
              <li><a target='__blank' href={googleDocLink}>
                {`Google Doc: ${currPart.title}`}
              </a></li>
            )}
          </ul>
        )}
      </div>
      {!isLoading && (
        <Table
          columns={columns}
          data={hasData ? assessments : createEmptyTableData(['username', 'results', 'score'])}
          assessmentRowRenderer={assessmentRowRenderer}
          className="mgt-40"
        />
      )}
      <AssessmentModal assessmentData={assessmentModalData} onClose={() => setAssessmentModalData({})} />
    </div>
  );
};

export default Ticket;
